// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.templates-items-templates-holder .module-list-item {
  float: left;
  margin: 10px;
  border: 2px solid var(--fi-border-color-light);
  border-radius: 14px;
  overflow: hidden;
  height: 130px;
  width: 130px;
  text-align: center;
  padding: 5px 0;
  line-height: 1;
}
.templates-items-templates-holder .module-list-item .item-icon {
  height: 90px;
  color: var(--fi-color-light);
  font-size: 64px;
}
.templates-items-templates-holder .module-list-item .item-icon .fa:before {
  font-size: 140%;
}
.templates-items-templates-holder .module-list-item .item-name {
  color: var(--fi-color-default);
}`, "",{"version":3,"sources":["webpack://./Source/app/document-template/document-template-models-list/document-template-models-list.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,YAAA;EACA,8CAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAAR;AAEQ;EACI,YAAA;EACA,4BAAA;EACA,eAAA;AAAZ;AAGgB;EACI,eAAA;AADpB;AAMQ;EACI,8BAAA;AAJZ","sourcesContent":[".templates-items-templates-holder {\r\n    .module-list-item {\r\n        float: left;\r\n        margin: 10px;\r\n        border: 2px solid var(--fi-border-color-light);\r\n        border-radius: 14px;\r\n        overflow: hidden;\r\n        height: 130px;\r\n        width: 130px;\r\n        text-align: center;\r\n        padding: 5px 0;\r\n        line-height: 1;\r\n\r\n        .item-icon {\r\n            height: 90px;\r\n            color: var(--fi-color-light);\r\n            font-size: 64px;\r\n\r\n            .fa {\r\n                &:before {\r\n                    font-size: 140%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .item-name {\r\n            color: var(--fi-color-default);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
